import { ff } from '@atlassian/jira-feature-flagging-using-meta';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';

export const useInsight = () => {
	const route = useCurrentRoute();

	if (route.navigation) {
		return route.navigation.menuId === 'INSIGHT';
	}

	return false;
};

export const useInsightObjectSchemaSidebar = () => {
	const route = useCurrentRoute();
	if (ff('jsm-nav-refresh-assets_dkzd9')) return false;
	return route.name === 'servicedesk-cmdb-object-schema';
};
